import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

export const CallToActionBlock: React.FC<CTABlockProps> = ({ links, richText }) => {
  return (
    <div className="bg-custom-blue">
      <div className="container px-4 py-8">
        <div className="flex flex-col gap-8 lg:flex-row lg:justify-between lg:items-start">
          <div className="flex items-start justify-start">
            {richText && <RichText className="mb-0 w-full" data={richText} enableGutter={false} />}
          </div>
          <div className="flex flex-col gap-4">
            {(links || []).map(({ link }, i) => {
              return <CMSLink key={i} size="lg" {...link} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
